module.exports = "import React from 'react';\n\nimport Lozenge from '../../src';\n\nexport default () => <Lozenge>Subtle default lozenge</Lozenge>;\n"